'use es6';

import PropTypes from 'prop-types';
import CalloutTypeList from './CalloutTypeList';
import { jsx as _jsx } from "react/jsx-runtime";
function CalloutInsertPopoverBody(props) {
  const {
    onInsertCallout
  } = props;
  return /*#__PURE__*/_jsx("div", {
    className: "p-x-0 p-y-1",
    children: /*#__PURE__*/_jsx(CalloutTypeList, {
      buttonClassName: "p-x-5 p-y-2",
      onClick: onInsertCallout
    })
  });
}
CalloutInsertPopoverBody.propTypes = {
  onInsertCallout: PropTypes.func.isRequired
};
export default CalloutInsertPopoverBody;